<template>
  <div>
    <div>
      <ServerValueSourcePicker
        v-model="editSource"
        title="Value Source"
        :isRequired="isRequired"
      />
    </div>
    <div class="pt-6">
      <FilterFunctionPicker
        v-if="editSource == 'function'"
        v-model="editValue"
        title="Function Name"
      />
      <v-text-field
        v-else-if="editSource == 'data'"
        filled
        v-model="editValue"
        hide-details
        label="Data Field Name"
      ></v-text-field>
      <v-text-field
        v-else-if="editSource == 'variable'"
        filled
        v-model="editValue"
        hide-details
        label="Variable Name"
      ></v-text-field>
      <ValuePicker v-else title="Value" :type="valueType" v-model="editValue" />
    </div>
    <div class="pt-6">
      <DataTypePicker title="Value Type" v-model="valueType" class="mb-6" />
    </div>
  </div>
</template>

<script>
import ServerValueSourcePicker from "./ServerValueSourcePicker.vue";
import ValuePicker from "./ValuePicker.vue";
import FilterFunctionPicker from "./FilterFunctionPicker.vue";
import DataTypePicker from "./DataTypePicker.vue";

export default {
  name: "ServerValuePicker",

  components: {
    ServerValueSourcePicker,
    ValuePicker,
    FilterFunctionPicker,
    DataTypePicker,
  },

  props: ["value", "type", "table", "isRequired", "title"],

  data() {
    return {
      editSource: "value",
      editValue: null,
      valueType: "text",
    };
  },

  watch: {
    value() {
      this.refresh();
    },
    editValue() {
      this.updateValue();
    },
    editSource() {
      this.updateValue();
    },
    type(v) {
      this.valueType = v;
    },
    valueType() {
      this.updateValue();
    },
  },

  mounted() {
    this.refresh();
  },

  methods: {
    updateValue() {
      if (this.editSource == "value") {
        this.$emit("input", this.editValue);
      } else {
        this.$emit(
          "input",
          this.editSource + "." + (this.editValue ? this.editValue : "")
        );
      }

      this.$emit("value-type", this.valueType);
    },
    refresh() {
      if (this.value) {
        var sa = this.value.toString().split(".");

        if (sa.length == 2) {
          this.editSource = sa[0];
          this.editValue = sa[1];
        } else {
          this.editSource = "value";
          this.editValue = this.value;
        }
      } else {
        this.editSource = "value";
        this.editValue = null;
      }

      this.valueType = this.type;
    },
  },
};
</script>
